/**
 * AnomalyDetector.ts - Detect suspicious context changes
 * 
 * CHANGE HISTORY:
 * - 251027_1747 danielbeer: Stub implementation (to be enhanced later)
 */

import type { Context, AnomalyRule, Anomaly } from '../types';

export class AnomalyDetector {
  private rules: AnomalyRule[] = [];
  private anomalies: Anomaly[] = [];

  registerRule(rule: AnomalyRule): void {
    this.rules.push(rule);
  }

  check(_current: Context, _previous?: Context): Anomaly[] {
    // Stub - will implement full anomaly detection later
    return [];
  }

  getAnomalies(): Anomaly[] {
    return this.anomalies;
  }

  clearAnomalies(): void {
    this.anomalies = [];
  }
}
